/* eslint-disable import/no-anonymous-default-export */
import { ProjectList } from './ProjectList';
import { ProjectShow } from './ProjectShow';
import { QuoteJobFolder } from '@/types';

export default {
    list: ProjectList,
    show: ProjectShow,
    recordRepresentation: (record: QuoteJobFolder) => record?.name,
};
